// Mirrors src/components/common/TagBadge.tsx — small dot + tag id, sized
// small (xs) or medium (sm).

import React from 'react'
import clsx from 'clsx'

interface TagBadgeProps {
  tagId: string
  isActive?: boolean
  size?: 'small' | 'medium'
}

export const TagBadge: React.FC<TagBadgeProps> = ({
  tagId,
  isActive = true,
  size = 'small',
}) => {
  const medium = size === 'medium'
  return (
    <div
      className={clsx(
        'inline-flex items-center gap-1',
        medium ? 'px-md py-xs' : 'px-sm py-[3px]',
      )}
    >
      <span
        className={clsx(
          'h-1.5 w-1.5 rounded-full',
          isActive ? 'bg-statusGreen' : 'bg-statusRed',
        )}
      />
      <span
        className={clsx(
          'font-medium text-textPrimary',
          medium ? 'text-sm' : 'text-xs',
        )}
      >
        {tagId}
      </span>
    </div>
  )
}
